import React, { Component } from "react";
import { Container, Grid } from '@material-ui/core';
import { HeaderBarContainer } from './header-bar/header-bar-container';
import HeaderBar from './header-bar/header-bar';
import AddEditJobModal from './add-edit-job-modal/add-edit-job-modal';
import * as engineersService from './services/user-service';
import * as jobsService from './services/jobs-service';
import ManagementJobList from "./management-job-list/management-job-list";

export default class JobManagment extends Component {
    constructor() {
        super();
        this.state = {
            currentDate: new Date(),
            engineers: [],
            jobs: [],
            selectedEngineer: {},
            selectedJob: {},
            isAddJobModalOpen: false
        }
    }

    componentDidMount = () => {
        engineersService.getEngineers().then((result) => this.setState({ engineers: result }));
        this.initDaysJobs(this.state.currentDate);
    };

    changeDay = (selectedDate) => {
        this.setState({
            currentDate: selectedDate,
        });

        this.initDaysJobs(selectedDate);
    };

    initDaysJobs = (date) => {
        jobsService.getDaysJobs(date)
            .then((jobs) => {
                this.setState({
                    jobs: jobs
                });
            });
    }

    addJob = (engineer) => {
        this.setState({
            isAddJobModalOpen: true,
            selectedJob: {
                addressLine1: null,
                addressLine2: null,
                postCode: null,
                city: null,
                description: null,
                notes: null,
                jobNumber: null,
                assignments: [
                    {
                        id: 1,
                        engineerId: engineer.id,
                        duration: 0.5,
                        appointmentDate: this.state.currentDate,
                        appointmentTime: null,
                        timeslot: "AT",
                        value: 0
                    }
                ]
            }
        });
    };

    editJob = (job) => {
        jobsService
            .getJob(job.id)
            .then((job) => {
                this.setState({
                    isAddJobModalOpen: true,
                    selectedJob: job
                });
            });
    };

    deleteJob = (job) => {
        jobsService.deleteJob(job.id).then(() => {
            this.setState({ jobs: this.state.jobs.filter(j => j.id !== job.id) });
        })
        .catch(error => {
            console.error(error.message);
            alert("Unable to delete job.");
        });
    }

    onModalClosed = () => {
        this.setState({
            isAddJobModalOpen: false,
            selectedJob: {}
        });
    }

    onJobSaved = () => {
        this.initDaysJobs(this.state.currentDate);
    }

    render() {
        return (<div>
            <HeaderBarContainer>
                <HeaderBar
                    user={this.props.user}
                    currentDate={this.state.currentDate}
                    onChangeDay={this.changeDay}
                />
            </HeaderBarContainer>
            <Container>
                <Grid container justify="flex-start" spacing={2}>
                    {this.state.engineers.map((engineer, index) => {
                        return <Grid item xs={12} sm={6} md={4} key={index}> 
                            <ManagementJobList 
                                engineer={engineer} 
                                engineerIndex={index}
                                jobs={this.state.jobs.filter(j => j.engineerId === engineer.id)}
                                editJob={this.editJob}
                                addJob={this.addJob}
                                deleteJob={this.deleteJob} />
                        </Grid>
                    })}
                </Grid>
            </Container>
            <AddEditJobModal
                engineerList={this.state.engineers}
                isOpen={this.state.isAddJobModalOpen}
                onModalClosed={this.onModalClosed}
                appointmentDate={this.state.currentDate}
                engineerId={this.state.selectedEngineer.id}
                job={this.state.selectedJob}
                onJobSaved={this.onJobSaved} />
        </div>);
    }
}